<template>
  <div class="animated fadeIn mt-5">
    <form @submit="validateBeforeSubmit($event, false)">
      <div class="row">
        <b-col md="12">
          <b-card>
            <div slot="header">
              <strong>Tipo de Campanha</strong>
            </div>

            <!-- NAME -->
            <b-form-group label="Nome">
              <b-form-input
                type="text"
                name="name"
                v-model="item.name"
                placeholder="Nome"
                v-validate="'required'"
                :state="validateState('name')"
              />
              <b-form-invalid-feedback>
                {{ errors.first("name") }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-row>
              <!-- CODE -->
              <b-col md="4">
                <b-form-group label="Código">
                  <b-form-input
                    type="text"
                    name="code"
                    v-model="item.code"
                    placeholder="Código"
                    v-validate="'required'"
                    :state="validateState('code')"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first("code") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <!-- LEADERS -->
              <b-col md="4">
                <b-form-group label="Campanha de Líderes">
                  <b-form-select
                    :options="yesNoOptions"
                    name="leaders"
                    v-model="item.leaders"
                    v-validate="'required'"
                    :state="validateState('leaders')"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first("leaders") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <!-- POINTS -->
              <b-col md="4">
                <b-form-group label="Pontos">
                  <b-form-select
                    :options="yesNoOptions"
                    name="points"
                    v-model="item.points"
                    v-validate="'required'"
                    :state="validateState('points')"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first("points") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <!-- PRIZES -->
              <b-col md="4">
                <b-form-group label="Prémios">
                  <b-form-select
                    :options="yesNoOptions"
                    name="prizes"
                    v-model="item.prizes"
                    v-validate="'required'"
                    :state="validateState('prizes')"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first("prizes") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <!-- START DATE -->
              <b-col md="4">
                <b-form-group label="Início">
                  <b-form-datepicker
                    name="date_start"
                    v-model="item.date_start"
                    locale="pt-PT"
                    date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                    :state="validateState('date_start')"
                    v-validate="'required'"
                  ></b-form-datepicker>
                  <b-form-invalid-feedback>
                    {{ errors.first("date_start") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <!-- END DATE -->
              <b-col md="4">
                <b-form-group label="Fim">
                  <b-form-datepicker
                    name="date_end"
                    v-model="item.date_end"
                    locale="pt-PT"
                    date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                    :state="validateState('date_end')"
                  />
                </b-form-group>
              </b-col>

              <!-- STATE -->
              <b-col md="4">
                <b-form-group label="Estado">
                  <b-form-select
                    :options="stateOptions"
                    name="state"
                    v-model="item.state"
                    v-validate="'required'"
                    :state="validateState('state')"
                  />
                  <b-form-invalid-feedback>
                    {{ errors.first("state") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-form-row>

            <div slot="footer">
              <div class="row">
                <div class="col-sm-3">
                  <router-link :to="{ name: 'Bestoftypes.index' }">
                    <i class="fa fa-ban"></i> Cancelar
                  </router-link>
                </div>

                <div class="col-sm-9 text-right">
                  <b-button type="submit" size="sm" variant="primary">
                    <i class="fa fa-save"></i> Gravar
                  </b-button>

                  <b-button
                    type="button"
                    @click="validateBeforeSubmit($event, true)"
                    size="sm"
                    variant="primary"
                  >
                    <i class="fa fa-save"></i> Gravar e fechar
                  </b-button>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </div>
    </form>
  </div>
</template>

<script>
import lists from "@/components/States.js";

export default {
  name: "BestofEdit",
  props: ["id"],

  data() {
    return {
      stateOptions: lists.states,

      yesNoOptions: [
        { value: null, text: "Escolha uma opção" },
        { value: 1, text: "Sim" },
        { value: 0, text: "Não" },
      ],

      item: {
        id: null,
        code: "",
        name: "",
        leaders: null,
        points: null,
        prizes: null,
        date_start: "",
        date_end: "",
        state: 1,
      },
    };
  },

  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault();

      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.submit(close);
        } else {
          this.$bvToast.toast("Tem campos inválidos", {
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
        }
      });
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    submit(close) {
      const payload = { ...this.item };

      if (this.item.id) {
        // UPDATE
        this.axios
          .put(`bestof/campaign-types/${this.item.id}`, payload)
          .then((res) => {
            this.$bvToast.toast("Item gravado com sucesso", {
              variant: "success",
              solid: true,
              autoHideDelay: 4000,
            });

            if (close) return this.$router.push({ name: "Bestoftypes.index" });
          })
          .catch((err) => {
            let message = "Erro ao criar item";

            // Backend validation errors (Laravel-style)
            if (err.response && err.response.data) {
              const data = err.response.data;

              if (data.errors) {
                message = Object.values(data.errors).flat().join("\n");
              } else if (data.message) {
                message = data.message;
              }
            }

            this.$bvToast.toast(message, {
              title: "Erro",
              variant: "danger",
              solid: true,
              autoHideDelay: 7000,
            });
          });
      } else {
        // CREATE
        this.axios
          .post("bestof/campaign-types", payload)
          .then((res) => {
            const newId = res.data.data.id;

            this.$bvToast.toast("Tipo de campanha criada com sucesso", {
              variant: "success",
              solid: true,
              autoHideDelay: 4000,
            });

            if (close) return this.$router.push({ name: "Bestoftypes.index" });

            return this.$router.push({
              name: "Bestoftypes.edit",
              params: { id: newId },
            });
          })
          .catch((err) => {
            let message = "Erro ao criar item";

            // Backend validation errors (Laravel-style)
            if (err.response && err.response.data) {
              const data = err.response.data;

              if (data.errors) {
                message = Object.values(data.errors).flat().join("\n");
              } else if (data.message) {
                message = data.message;
              }
            }

            this.$bvToast.toast(message, {
              title: "Erro",
              variant: "danger",
              solid: true,
              autoHideDelay: 7000,
            });
          });
      }
    },
  },

  created() {
    const id = this.$route.params.id;
    if (id) {
      this.axios
        .get(`bestof/campaign-types/${id}`)
        .then((res) => {
          this.item = res.data.data;
        })
        .catch(() => {
          this.$bvToast.toast("Este item não existe", {
            variant: "danger",
            solid: true,
          });
          this.$router.push({ name: "Bestoftypes.index" });
        });
    }
  },
};
</script>
